import Promise from 'bluebird';
import {
    getConfig,
    checkRegCode,
    getAuthenticateUrl,
    getAuthSuccessUrl,
    getAuthErrorUrl
} from 'lib/api/AdobeClientlessAPI';
import {
    configSelector,
    regCodeSelector
} from 'selectors/activationSelectors';
import { ModalType } from 'enums';
import { displayModalMessage } from './appActions';

export const GET_CONFIG = 'GET_CONFIG';
export const CHECK_REG_CODE = 'CHECK_REG_CODE';
export const AUTHENTICATE = 'AUTHENTICATE';
export const GENERIC_ERROR = 'GENERIC_ERROR';
export const INVALID_ERROR = 'INVALID_ERROR';

// Action Creators
export function createGetConfigAction(mvpd, message) {
    return {
        type: GET_CONFIG,
        mvpd,
        message
    };
}

export function createCheckRegCodeAction(
    code,
    mvpd,
    deviceType,
    provider,
    message
) {
    return {
        type: CHECK_REG_CODE,
        code,
        provider,
        mvpd,
        deviceType,
        message
    };
}

export function createAuthenticateAction(authUrl, authSuccessUrl, authErrorUrl, useIframe) {
    return {
        type: AUTHENTICATE,
        authUrl,
        authSuccessUrl,
        authErrorUrl,
        useIframe
    };
}

export function createGenericErrorAction(message) {
    return {
        type: GENERIC_ERROR,
        message
    };
}

export function createInvalidErrorAction(message) {
    return {
        type: INVALID_ERROR,
        message
    };
}

// Actions
export function getClientlessConfig() {
    return (dispatch) => (
        getConfig()
            .then(response => {
                const { requestor: { mvpds: { mvpd = [] } = {} } = {}, message } = response;
                return dispatch(createGetConfigAction(mvpd, message));
            })
    );
}

export function checkClientlessRegCode(regCode, providerId, provider) {
    return (dispatch) => (
        checkRegCode(regCode)
            .then(response => {
                const { info: { deviceType } = {}, message } = response;
                dispatch(createCheckRegCodeAction(regCode, providerId, deviceType, provider, message));
            })
    );
}

export function clientlessAuthenticate({
    regCode,
    mvpd,
    deviceType,
    provider,
    baseUrl = window.location.href
}) {
    return (dispatch) => {
        const authUrl = getAuthenticateUrl({ regCode, mvpd, deviceType, baseUrl });
        const authSuccessUrl = getAuthSuccessUrl({ mvpd, deviceType, baseUrl });
        const authErrorUrl = getAuthErrorUrl({ baseUrl });
        const useIframe = provider.iFrameRequired && provider.iFrameRequired.value && window.innerWidth > 500;

        dispatch(createAuthenticateAction(authUrl, authSuccessUrl, authErrorUrl, useIframe));

        try {
            if (useIframe) {
                // open url in an iframe (use modal)
                dispatch(displayModalMessage(ModalType.IFRAME_AUTH, {
                    src: authUrl,
                    width: (provider.iFrameWidth && provider.iFrameWidth.value) || 500,
                    height: (provider.iFrameHeight && provider.iFrameHeight.value) || 500
                }));
            } else {
                window.location.href = authUrl;
            }
        } catch (err) {
            return Promise.reject(err);
        }

        return Promise.resolve(authUrl);
    };
}

export function activate(regCode, providerId) {
    return (dispatch, getState) => (
        dispatch(getClientlessConfig())
            .then(() => {
                const { mvpd, message } = configSelector(getState());
                if (message) {
                    return dispatch(createGenericErrorAction(message));
                }

                const selectedProvider = mvpd.filter(provider => provider.id.value === providerId).shift();
                if (selectedProvider) {
                    return dispatch(checkClientlessRegCode(regCode, providerId, selectedProvider));
                }

                return dispatch(createGenericErrorAction(message));
            })
            .then(() => {
                const { code, mvpd, deviceType, provider, message } = regCodeSelector(getState());
                if (message) {
                    return dispatch(createInvalidErrorAction(message));
                }

                return dispatch(clientlessAuthenticate({
                    regCode: code,
                    mvpd,
                    deviceType,
                    provider,
                    baseUrl: window.location.href
                }));
            })
            .catch((err) => dispatch(createGenericErrorAction(err.message)))
    );
}



// WEBPACK FOOTER //
// ./app/common/actions/activationActions.js